// Страница-благодарность /pages/vertrag-widerrufen-eingegangen — номер
// договора и время прихода приходят через query (?ref=...&ts=...&status=retry),
// Liquid не имеет доступа к query string, поэтому читаем и подставляем на клиенте.
function initWiderrufEingegangen(root) {
	const block = root.querySelector('[data-widerruf-eingegangen]');
	if (!block) return;

	const params = new URLSearchParams(window.location.search);
	const ref = params.get('ref');
	const ts = params.get('ts');
	const status = params.get('status');

	const okEl = block.querySelector('[data-widerruf-eingegangen-ok]');
	const retryEl = block.querySelector('[data-widerruf-eingegangen-retry]');
	const missingEl = block.querySelector('[data-widerruf-eingegangen-missing]');
	const detailsEl = block.querySelector('[data-widerruf-eingegangen-details]');
	const timestampEl = block.querySelector('[data-widerruf-eingegangen-timestamp]');
	const referenceEl = block.querySelector('[data-widerruf-eingegangen-reference]');
	const emailNoteEl = block.querySelector('[data-widerruf-eingegangen-email-note]');

	if (!ref) {
		if (okEl) okEl.hidden = true;
		if (retryEl) retryEl.hidden = true;
		if (detailsEl) detailsEl.hidden = true;
		if (emailNoteEl) emailNoteEl.hidden = true;
		if (missingEl) missingEl.hidden = false;
		return;
	}

	if (referenceEl) referenceEl.textContent = ref;
	if (timestampEl && ts) timestampEl.textContent = ts;
	if (detailsEl) detailsEl.hidden = false;

	if (status === 'retry') {
		if (okEl) okEl.hidden = true;
		if (retryEl) retryEl.hidden = false;
	}

	block.focus();
}

document.querySelectorAll('.widerruf-form').forEach(initWiderrufEingegangen);
